import { NsContent } from 'components/common/ns-content/NsContent';

const BusinessAnnouncementHeader = () => {
  return (
    <NsContent>
      <h1>Please come back later</h1>
    </NsContent>
  );
};

export default BusinessAnnouncementHeader;
